import { Image } from "antd";
import { serverImgFullPath } from "../../../utils/Common";
import { useState } from "react";
import Helper from "../../../utils/Helper";

export default function BranchDetailComponent({
  records = {
    data: {
      branchId: "",
      parentRestaurantId: "",
      restaurantName: "",
      branchName: "",
      status: "",
      latitude: 0.0,
      longitude: 0.0,
      address: "",
      countryCode: "",
      phone: "",
      email: "",
      categories: [],
      openTime: "",
      closeTime: "",
      openDays: [],
      logo: "",
      banner: "",
      offerImage: "",
      images: [],
      vat: "0.00",
      serviceCharge: "0.00",
      isVatIncluded: false,
      paymentOptions: [],
      inventoryType: "",
      webAddress: "",
      socialLink: ""
    },
  },
}) {
  const theOpenTime = useState(Helper.get12HrTimeOnly(records.data.openTime));
  const theCloseTime = useState(Helper.get12HrTimeOnly(records.data.closeTime));

  return (
    <section>
      <div className={"bg-[#FAFAFA]"}>
        <div className="min-h-[643px] px-[16px]">
          <div className="w-full h-full">
            {/* banner */}
            <div className="text-center max-h-[251px] relative detail-banner-img">
              <Image
                src={serverImgFullPath(records.data.banner)}
                preview={false}
                fallback={"/images/temp-restaurant-banner.jpg"}
                height={251}
              />
              {/* restaurant profile header */}
              <div className="px-[40px] w-full absolute bottom-[-50px]">
                {/* profile picture */}
                <div className="relative">
                  <div
                    className="w-[74px] h-[74px] bg-[#572D86] 
                flex items-center justify-center rounded-full"
                  >
                    <Image
                      src={``}
                      fallback="/images/icons/user.svg"
                      width={50}
                      height={50}
                      preview={false}
                      alt="profile-picture"
                      className="rounded-full"
                    />
                  </div>
                  <div
                    className="absolute left-[80px] bottom-[-13px] flex items-center 
                    justify-between w-[calc(100%-80px)]"
                  >
                    {/* user name or restaurant name */}
                    <div className=" flex items-center">
                      <Image src="/images/icons/edit.svg" preview={false} alt="edit" />
                      <h1
                        className="ml-[44px] text-[22px] font-semibold leading-[35px] 
                  tracking-[0.88px] font-p_semibold text-black"
                      >
                        Admin
                      </h1>
                    </div>

                    {/* restaurant logo */}
                    <div className="min-w-[200px] flex items-center justify-center">
                      <Image
                        src={serverImgFullPath(records.data.logo)}
                        alt="restaurant-logo"
                        fallback="/images/temp-res-logo.svg"
                        preview={false}
                        height={50}
                        width={50}
                        className="rounded-xl"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* detail section */}
          <div className="mt-[50px] px-[40px] pt-[20px] flex items-end justify-between">
            {/* info section - left */}
            <div>
              <div className="text-black mb-[15px]">
                <h1 className="font-p_semibold text-[22px] leading-[35px] tracking-[0.88px]">
                  {records.data.restaurantName}
                </h1>
                <p className="font-p_regular text-[14px] leading-[35px] tracking-[0.56px] pl-[20px]">
                  {records.data.branchName}
                </p>
              </div>

              {/* address */}
              <div className="flex items-center space-x-[8.95px] mb-[14px]">
                <Image src="/images/icons/address.svg" alt="address" preview={false} />
                <div className="text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.countryCode}
                  {records.data.phone}
                </div>
              </div>
              <div className="text-black flex items-center space-x-[8.95px] mb-[14px]">
                <Image src="/images/icons/location.svg" alt="address" preview={false} />
                <div className="max-w-[212px] text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.address}
                </div>
              </div>
              <div className="text-black flex items-center space-x-[8.95px] mb-[14px]">
                <Image src="/images/icons/web.svg" alt="address" preview={false} />
                <div className="max-w-[212px] text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.webAddress}
                </div>
              </div>
              <div className="text-black flex items-center space-x-[8.95px] mb-[14px]">
                <Image src="/images/icons/link.svg" alt="address" preview={false} />
                <div className="max-w-[212px] text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.socialLink}
                </div>
              </div>
              <div className="text-black flex items-center space-x-[8.95px] mb-[14px]">
                {/* <Image src="/images/icons/link.svg" alt="address" preview={false} /> */}
                <p className="font-p_regular">Is Vat Included</p>
                <div className="max-w-[212px] text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.isVatIncluded ? "Yes" : "No"}
                </div>
              </div>
              <div className="text-black flex items-center space-x-[8.95px] mb-[14px]">
                {/* <Image src="/images/icons/link.svg" alt="address" preview={false} /> */}
                <p className="font-p_regular">VAT</p>
                <div className="max-w-[212px] text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.vat}
                </div>
              </div>
              <div className="text-black flex items-center space-x-[8.95px] mb-[14px]">
                {/* <Image src="/images/icons/link.svg" alt="address" preview={false} /> */}
                <p className="font-p_regular">Service charge</p>
                <div className="max-w-[212px] text-[#828282] text-[14px] leading-[21px] font-p_regular">
                  {records.data.serviceCharge}
                </div>
              </div>
              <div className="flex items-center space-x-[8.95px] mb-[14px]">
                <Image src="/images/icons/time.svg" alt="address" preview={false} />
                <div className="text-[#F58B29] text-[14px] leading-[21px] font-p_regular">
                  <span>Open {theOpenTime} - </span>
                  <span>Close {theCloseTime}</span>
                </div>
              </div>
            </div>

            {/* offer section - right */}
            <div>
              <div>
                <div className="max-w-[235px] max-h-[134px] mb-[18px]">
                  <Image
                    src="/images/temp-offer-img.jpg"
                    alt="offer-img"
                    preview={false}
                    width={235}
                    height={134}
                    className="rounded-2xl"
                  />
                </div>
                <div className="font-p_bold flex items-center gap-x-[18px]">
                  <button className="bg-[#FCBD10] text-black py-[13px] px-[36px] rounded-lg">Menu</button>
                  <button className="bg-black text-white py-[13px] px-[36px] rounded-lg">Order</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
